var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Parallax',{attrs:{"image":_vm.imageParallax.image1}}),_c('Title'),_c('Parallax',{attrs:{"image":_vm.imageParallax.image2}}),_c('Intro'),_c('Choices'),_c('Footer',{attrs:{"picture":_vm.picture}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }